/**
 * Whose screen this is, when it is not the user's own: a replay or an operator on the session. Plain
 * text with an icon, made to sit in a top bar; nothing for the kiosk itself. RoleBanner shows it over
 * the screen only when the layout has no top bar.
 */
import { useApp } from '../react/app';
import { useTranslate } from '../react/hooks';
import { Icon } from '../ui-kit/Icon';
import css from './RoleLabel.module.css';

/** `compact`: without the session id (a top bar with little room); the full text is in the tooltip. */
export function RoleLabel({ className = '', compact = false }: { className?: string; compact?: boolean }) {
  const { kiosk } = useApp();
  const t = useTranslate();
  if (kiosk.role === 'kiosk') return null;
  const id = kiosk.sessionId.slice(0, 8);
  const role = kiosk.role === 'operator' ? 'role.operator' : 'role.replay';
  return (
    <span className={`${css.label} ${css[kiosk.role]} ${className}`} role="status" title={t(role, { id })}>
      <Icon name={kiosk.role === 'operator' ? 'operator' : 'play'} size={20} />
      <span className={css.text}>{t(compact ? `${role}_tag` : `${role}_short`, { id })}</span>
    </span>
  );
}
